<template>
  <table :class="$style.userTable">
    <tbody>
      <tr
        v-for="i in 11"
        :key="i"
      >
        <td class="px-2 py-1">
          <div class="flex items-center justify-between gap-2">
            <p class="w-48 h-9 bg-bg-primary animate-pulse rounded-lg" />
            <p class="w-full h-9 bg-bg-primary animate-pulse rounded-lg" />
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style module lang="scss">
.userTable {
  @apply w-full gap-1 border-separate border-spacing-y-1.5;
}
</style>
